import { measureTextWidth } from './measureTextWidth';

/** Width of the widest whitespace-separated word in the text for the given font. */
export function longestWordWidth(text: string, fontName: string): number {
  return text
    .split(/\s+/)
    .reduce((max, word) => Math.max(max, measureTextWidth(word, fontName)), 0);
}
